import React, {useState,useEffect} from 'react'
import {
    useParams,
    Navigate,
    Link
} from 'react-router-dom';
import axios from "axios"
import Loader from '../../../components/Loader';
import axiosInstance from '../../../utils/api';

type Props = {}

interface ComponentInterface {
    id?: string;
    name: string;
    type: string;
    supplier: string;
    category: string;
    remark: string;
}

const defaultData = {
    name: "",
    type: "",
    supplier: "",
    category: "",
    remark: ""
}

const ComponentAddEdit = (props: Props) => {
    const {type, id} = useParams()
    const [loading, setLoading] = useState(false)
    const [inputs, setInputs] = useState([defaultData])
    const [input, setInput] = useState<ComponentInterface>(defaultData)
    const [sensorNameList, setSensorNameList] = useState<Array<ComponentInterface>>([])

    useEffect(() => {
        setLoading(true)
        axiosInstance.get(`https://api.cl-ds.com/internal/operations/v1/page/component/`).then(res => {
            setLoading(false)
            console.log(11, res.data.component)
            setSensorNameList(res.data.component)
        }).catch( err => {
            setLoading(false)
            console.log("[ERR]", err)
        })
        if (type=="edit" && id) {
            getData(id)
        }
    }, [])


    if (type!="add"&&type!="edit") {
        console.log(1, type)
        return <Navigate to="/" replace={true} />
    } else if (type=="add"&& id) {
        console.log(2, type)
        return <Navigate to="/" replace={true} />
    } else if (type=="edit"&& !id) {
        console.log(3, type)
        return <Navigate to="/" replace={true} />
    }

    
    function getData(id:string):void {
        setLoading(true)
        axiosInstance.get(`https://api.cl-ds.com/internal/operations/v1/component/${id}`).then(res => {
            setLoading(false)
            console.log(12, res)
            setInput(res.data)
        }).catch(err => {
            setLoading(false)
            console.log(234, err)
            return <Navigate to="/" replace={true} />
        })
    }
    

    function handleSubmit() {
        if (type=="add") {
            console.log("add", input)

            if (input.name.length < 1) {
                return alert("Name is required")
            }
            setLoading(true)
            axiosInstance.post("https://api.cl-ds.com/internal/operations/v1/component/", input).then((res:any) =>{
                setLoading(false)
                alert(res.data.message)
            }).catch( err => {
                setLoading(false)
                console.log(222, err)
            })
        } else {
            console.log("edit", input)

            if (input.name.length < 1) {
                return alert("Name is required")
            }

            setLoading(true)
            axiosInstance.put(`https://api.cl-ds.com/internal/operations/v1/component/${id}/`, input).then((res:any) =>{
                setLoading(false)
                alert(res.data.message)
            }).catch( err => {
                setLoading(false)
                console.log(222, err)
            })
        }
    }

    function handleChange(e:React.ChangeEvent<HTMLInputElement>,field: string) {
        console.log("handleChange", inputs)
        setInput(prev => ({
            ...prev,
            [field]: e.target.value
        }))
    }

    function handleChangeSelect(e:React.ChangeEvent<HTMLSelectElement>) {
        console.log("handleChangeSelect", inputs)
        setInput(prev => ({
            ...prev,
            "category": e.target.value
        }))
    }

    return (
        <div className="col-12">
        {loading && ( <Loader/> )}

            <div className="card">
                <div className="card-body">
                <div style={{float: "right", margin: "1rem", marginLeft: 0, marginBottom: 0}}>
                    <Link  to={`/component`} className="nav-link collapsed">
                        <button type="button" className="btn btn-outline-secondary">Back</button>
                    </Link>
                </div>
                <h5 className="card-title">{type=="add" ? "Create" : "Edit"} Component</h5>

                    {type == "add" && 
                        <div>
                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Name</label>
                                <div className="col-sm-8">
                                    <input type="text" className="form-control" id="inputText" value={input.name} onChange={(e)=>handleChange(e, "name")}/>
                                </div>
                            </div>
                            
                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Category</label>
                                <div className="col-sm-8">
                                    <select className="form-select" aria-label="select" value={input.category} onChange={(e)=>handleChangeSelect(e)}>
                                        <option value={0} key="0">-- Please Select --</option>
                                        <option value="product" key="1">Product</option>
                                        <option value="pcba" key="2">PCBA</option>
                                        <option value="applicationboard" key="3">Application Board</option>
                                        <option value="project" key="4">Project</option>
                                        <option value="sensor" key="5">Sensor</option>
                                    </select>
                                </div>
                            </div>
                            
                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Type</label>
                                <div className="col-sm-8">
                                    <input type="text" className="form-control" id="inputText" value={input.type} onChange={(e)=>handleChange(e, "type")}/>
                                </div>
                            </div>
                            
                            
                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Supplier</label>
                                <div className="col-sm-8">
                                    <input type="text" className="form-control" id="inputText" value={input.supplier} onChange={(e)=>handleChange(e, "supplier")}/>
                                </div>
                            </div>
                            
                            
                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Remark</label>
                                <div className="col-sm-8">
                                    <input type="text" className="form-control" id="inputText" value={input.remark} onChange={(e)=>handleChange(e, "remark")}/>
                                </div>
                            </div>
                            
                        </div>
                    }

                    {type == "edit" && 
                        <>
                        <div>
                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Name</label>
                                <div className="col-sm-8">
                                    <input type="text" className="form-control" id="inputText" value={input.name} onChange={(e)=>handleChange(e, "name")}/>
                                </div>
                            </div>
                            
                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Category</label>
                                <div className="col-sm-8">
                                    <select className="form-select" aria-label="select" value={input.category} onChange={(e)=>handleChangeSelect(e)}>
                                        <option value={0} key="0">-- Please Select --</option>
                                        <option value="product" key="1">Product</option>
                                        <option value="pcba" key="2">PCBA</option>
                                        <option value="applicationboard" key="3">Application Board</option>
                                        <option value="project" key="4">Project</option>
                                        <option value="sensor" key="5">Sensor</option>
                                    </select>
                                </div>
                            </div>
                            
                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Type</label>
                                <div className="col-sm-8">
                                    <input type="text" className="form-control" id="inputText" value={input.type} onChange={(e)=>handleChange(e, "type")}/>
                                </div>
                            </div>
                            
                            
                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Supplier</label>
                                <div className="col-sm-8">
                                    <input type="text" className="form-control" id="inputText" value={input.supplier} onChange={(e)=>handleChange(e, "supplier")}/>
                                </div>
                            </div>
                            
                            
                            <div className="row mb-3">
                                <label className="col-sm-2 col-form-label">Remark</label>
                                <div className="col-sm-8">
                                    <input type="text" className="form-control" id="inputText" value={input.remark} onChange={(e)=>handleChange(e, "remark")}/>
                                </div>
                            </div>
                            
                        </div>
                        </>
                    }
                    
                    <div className="text-start">
                        <button type="button" className="btn btn-outline-info" onClick={()=>handleSubmit()}>Submit</button>
                    </div>          

                </div>
            </div>

        </div>
    )
}

export default ComponentAddEdit